import { useIsomorphicLayoutEffect, useLocalStorage } from '@pairy/react-hooks';

import { localStorageKey } from '../components/PdfViewer/localStorageKey';

const useGetFirstVisit = () => {
  const [isPdfViewerFirstVisit, setIsPdfViewerFirstVisit] = useLocalStorage(
    localStorageKey.isPdfViewerFirstVisit,
  );

  useIsomorphicLayoutEffect(() => {
    // 로컬 스토리지에 값이 없으면 첫 방문으로 간주
    if (isPdfViewerFirstVisit === undefined) {
      setIsPdfViewerFirstVisit(true);
    }
  }, [isPdfViewerFirstVisit]);

  return [isPdfViewerFirstVisit, setIsPdfViewerFirstVisit] as const;
};

export default useGetFirstVisit;
